export default function initAnimations() {
    const elements = document.querySelectorAll(".js-reveal");

    if (!elements.length || !document.body.classList.contains("has-animations") || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        elements.forEach((element) => element.classList.add("is-visible"));
        return;
    }

    if (!("IntersectionObserver" in window)) {
        elements.forEach((element) => element.classList.add("is-visible"));
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
            }
        });
    }, {rootMargin: "0px 0px -8%", threshold: 0.08});

    elements.forEach((element) => observer.observe(element));
}
